export default __webpack_public_path__ + "static/media/Olim6.7f1f6d2b.png";